<template>
    <div id="submissions"
         class="home-submissions">
        <div class="flex-space">
            <h2>
                Latest Registered Users:
            </h2>

            <div>
                <el-button type="info"
                           round
                           :loading="users.loading"
                           size="mini"
                           class="margin-left-half"
                           @click="getUsers">
                    Refresh
                </el-button>
                <el-button type="info"
                           round
                           :loading="users.loading"
                           size="mini"
                           class="margin-left-half"
                           @click="dialogFormVisible = true">
                    Add Location
                </el-button>
            </div>
        </div>

        <el-table :data="item"
                  stripe
                  size="medium">
            <el-table-column label="avatar">
                <template slot-scope="scope">
                    <img :src="scope.row.avatar"
                         :alt="scope.row.avatar"
                         height="20"
                         class="circle margin-right-half">

                    <!-- <router-link :to="'/@' + scope.row.username">{{ str_limit(scope.row.username, 15) }}</router-link>-->
                </template>
            </el-table-column>

            <el-table-column label="Location">
                <template slot-scope="scope">
                    <el-tag type="info"
                            v-if="scope.row.location"
                            size="mini">
                        {{scope.row.location}}
                    </el-tag>
                </template>
            </el-table-column>

            <!--<el-table-column label="Joined At">
                <template slot-scope="scope">
                    <el-tag type="info"
                            size="mini">
                        {{ date(scope.row.created_at) }}
                    </el-tag>
                </template>
            </el-table-column>-->

            <!--  <el-table-column fixed="right"
                               label="Operations"
                               width="180">
                  <template slot-scope="scope">
                      <el-button type="text"
                                 size="small">Details</el-button>

                      <el-button type="text"
                                 @click="banUser(scope.row.username)"
                                 size="small">Ban</el-button>
                  </template>
              </el-table-column>-->
        </el-table>
        <!--modal-->
        <el-dialog title="Add Location" :visible.sync="dialogFormVisible">
            <el-form label-position="top"
                     label-width="10px">
                <!--                <el-form-item label="Select Country">-->
                <!--                    <el-select-->
                <!--                            v-model="country"-->
                <!--                            filterable-->
                <!--                            allow-create-->
                <!--                            default-first-option-->
                <!--                            placeholder="Choose tags for your article">-->
                <!--                        <el-option-->
                <!--                                v-for="item in options5"-->
                <!--                                :key="item.value"-->
                <!--                                :label="item.label"-->
                <!--                                :value="item.value">-->
                <!--                        </el-option>-->
                <!--                    </el-select>-->

                <!--                    <el-alert v-for="e in errors.location"-->
                <!--                              :title="e"-->
                <!--                              type="error"-->
                <!--                              :key="e"></el-alert>-->
                <!--                </el-form-item>-->


                <el-form-item label="Country">
                    <el-input
                            placeholder="Please input"
                            v-model="country">
                    </el-input>

                    <el-alert v-for="e in errors.location"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>
                </el-form-item>


                <el-form-item label="Country code">
                    <el-input
                            placeholder="Please input"
                            v-model="countryCode">
                    </el-input>

                    <el-alert v-for="e in errors.countryCode"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>
                </el-form-item>


                <el-form-item label="Tag line">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="Please input"
                            v-model="tagline">
                    </el-input>

                    <el-alert v-for="e in errors.tagline"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>
                </el-form-item>
                <el-form-item label="Description">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="Please input"
                            v-model="description">
                    </el-input>

                    <el-alert v-for="e in errors.description"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>
                </el-form-item>
                <el-form-item
                        label="Photo(s):">
                    <el-upload class="upload-demo"
                               drag
                               :limit="20"
                               action="/api/photos"
                               :file-list="photos"
                               :on-preview="photoPreview"
                               :on-remove="removePhoto"
                               :on-success="successfulPhotoUpload"
                               :on-exceed="exceededPhotoFileCount"
                               :on-error="failedPhotoUpload"

                               with-credentials
                               accept=" .jpg, .jpeg, .png"
                               :headers="{ 'X-CSRF-TOKEN': csrf}">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Drop photo here or
                            <em>click to upload</em>
                        </div>
                        <div class="el-upload__tip"
                             slot="tip">Up to {{ photosNumberLimit }} jpg/png files with a size less than {{
                            photosSizeLimit }}mb
                        </div>
                    </el-upload>

                    <el-alert v-for="e in errors.avatar"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>

                </el-form-item>

                <!-- Select Channel -->


                <!-- NSFW Toggle -->


                <el-button round
                           type="success"
                           size="mini"
                           @click="submit"
                           :disabled="!validates"
                           :loading="loading">
                    Submit
                </el-button>


            </el-form>
        </el-dialog>


        <!--modal end-->
    </div>
</template>

<script>
    import Helpers from '../mixins/Helpers';
    import SubmitFormUpload from '../mixins/SubmitFormUpload'

    export default {
        mixins: [Helpers, SubmitFormUpload],

        created() {
            // this.loadData();
        },
        computed: {
            validates() {
                return this.country && this.description.trim() && this.photos.length;
            }
        },

        data() {
            return {
                dialogFormVisible: false,
                errors: [],

                loading: false,
                loadingChannels: false,
                selectedCat: null,
                suggestedCats: [],
                submissionType: 'News',
                title: '',
                sfw: true,
                typeOfSubmission: '',
                item: [],

                // Link
                submitURL: '',
                loadingTitle: false,

                // Text
                preview: false,
                text: '',

                // Photo
                photos: [],
                description: '',
                country: '',
                countryCode: '',
                tagline: '',
                photosNumberLimit: 1,
                photosSizeLimit: 10,
                previewPhotoImage: '',
                previewPhotoFileName: '',
                previewPhotoModal: false,

                // GIF
                // gifTempArray: [],
                // gif_id: null,
                // gifNumberLimit: 1,
                // gifSizeLimit: 50,
                // previewGifImage: '',
                // previewGifFileName: '',
                // previewGifModal: false
                users: {
                    items: [],
                    loading: false
                },

                formLabelWidth: '120px',
                options5: [],


            };
        },
        mounted() {
            // axios.get('/country').then(response=>this.location(response)).catch(error=>this.errorLocation(error));
        },

        methods: {
            // loadData() {
            //     this.$Progress.start();
            //     axios.get('/location').then((response) => {
            //         var result = response.data.data.map(item => ({
            //             avatar: item.avatar,
            //             location: item.name,
            //             id: item.id
            //         }));
            //         this.item = result;
            //         this.$Progress.stop();
            //
            //     }).catch((error) => {
            //         this.users.loading = false;
            //         this.$Progress.fail();
            //     });
            // },
            // location(response) {
            //     if (response.status == 200) {
            //
            //         var result = response.data.data.map(item => ({label: item.name, value: item.id}));
            //
            //         this.options5 = result;
            //     }
            // },
            // errorLocation(error) {
            //
            // },

            banUser(username) {
                Store.modals.banUser.username = username;
                Store.modals.banUser.show = true;
            },
            submit() {
                let formData = new FormData();

                formData.append('location', this.country);
                formData.append('code', this.countryCode);
                formData.append('description', this.description);
                formData.append('tagline', this.tagline);

                var path = this.photos[0].response.data.path;
                var thumbnail = this.photos[0].response.data.thumbnail_path;
                formData.append('avatar', path);
                formData.append('thumbnail', thumbnail);
                axios.post('/location', formData).then((response) => {
                    this.dialogFormVisible = false;
                    // this.loadData();
                    app.$message({
                        message: response.data.message,
                        type: "success",
                        showClose: true
                    });

                    this.country = "";
                    this.countryCode = "";
                    this.description = "";
                    this.tagline = "";
                    this.photos = [];
                    this.errors = [];
                }).catch((failed) => {
                    this.errors = failed.response.data.errors;
                });

            },


            getUsers() {
                this.$Progress.start();
                this.users.items = [];
                this.users.loading = true;

                axios
                    .get('/location')
                    .then(response => {
                        this.users.items = response.data.data;
                        this.users.loading = false;
                        this.$Progress.finish();
                    })
                    .catch(() => {
                        this.users.loading = false;
                        this.$Progress.fail();
                    });
            },

            date(date) {
                return moment(date)
                    .utc(moment().format('Z'))
                    .fromNow();
            }
        }
    };
</script>
<style scoped>
    .el-upload-dragger {
        background-color: #fff;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 605px !important;
        height: 180px;
        text-align: center;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .el-upload-dragger:hover {
        border-color: #5587d7;
        width: 605px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Location.vue